import React, { Component } from "react";
import moment from "moment";
import {
  Card,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Status,
} from "ui-kit-ck-consultant";

import {
  getValue,
  getCurrencyValue,
  getPercentageValue,
} from "../../../utils/general";

const evolution = (previous, current) =>
  previous && current != null
    ? Math.round(((current / previous) * 100 - 100) * 100) / 100
    : null;

const formatEvolution = (value) =>
  value == null ? "-" : getPercentageValue(value);

export class TableCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getDataMonth = (id) => {
    let tmpDataMonth = [];

    for (let index = 0; index < 12; index++) {
      if (parseInt(moment(this.props.dateEnd).format("MM")) > index) {
        tmpDataMonth.push(
          <Td key={index}>
            {this.formatValue(id, this.props.data[index][id])}
          </Td>
        );
      } else {
        tmpDataMonth.push(<Td key={index}></Td>);
      }
    }

    return tmpDataMonth;
  };

  formatValue = (id, value) => {
    if (value === null || value === undefined || id.startsWith("count")) {
      return value;
    }
    if (id === "percentageError") {
      return getPercentageValue(value);
    }
    if (id.startsWith("cost")) {
      return getCurrencyValue(value);
    }
    return getValue(value);
  };

  getColorStatus(value, reverse) {
    const text = formatEvolution(value);
    if ((value > 0 && !reverse) || (reverse && value < -0)) {
      return <Status className="bg-green w-100" text={text} />;
    } else if ((value < 0 && !reverse) || (reverse && value > -0)) {
      return <Status className="bg-red w-100" text={text} />;
    } else {
      return <Status className="bg-blue w-100" text={text} />;
    }
  }

  render() {
    return (
        <Card
          title={this.props.name}
          className="mb-10 mb-20-xl"
          classNameChildren="overflow-x-auto"
        >
          <Table>
            <Thead>
              <Tr>
                <Th></Th>
                <Th className="nowrap">N-1</Th>
                <Th>N</Th>
                <Th className="nowrap">N / N-1</Th>
                <Th>Janvier</Th>
                <Th>Février</Th>
                <Th>Mars</Th>
                <Th>Avril</Th>
                <Th>Mai</Th>
                <Th>Juin</Th>
                <Th>Juillet</Th>
                <Th>Août</Th>
                <Th>Septembre</Th>
                <Th>Octobre</Th>
                <Th>Novembre</Th>
                <Th>Décembre</Th>
              </Tr>
            </Thead>
            <Tbody>
              {this.props.labels.map((element, idx) => (
                <Tr key={idx}>
                  <Th className={this.props.isPrint ? "" : "nowrap"}>
                    {element.name}
                  </Th>
                  <Td>
                    {this.formatValue(
                      element.id,
                      this.props.data["N_1"][element.id]
                    )}
                  </Td>
                  <Td>
                    {this.formatValue(
                      element.id,
                      this.props.data["N"][element.id]
                    )}
                  </Td>
                  <Td className="nowrap">
                    {this.getColorStatus(
                      evolution(
                        this.props.data["N_1"][element.id],
                        this.props.data["N"][element.id]
                      ),
                      element.reverse
                    )}
                  </Td>
                  {this.getDataMonth(element.id)}
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Card>
    );
  }
}

export default TableCustom;
